export class CriteriaTranslateModel  {
    name = {
        en: '',
        de: '',
        fr: '',
        it: '',
    };
}
